import { Button, Flex, Image, Modal, Space } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import _ from "lodash";

import { FALLBACK_IMAGE } from "config";
import {
  DETAIL_FIELDS,
  DETECTED_CODE_TYPE_COLOR_MAP,
  FIELD_KEYS,
  FIELD_LABELS,
  FIELD_ORDERS,
} from "constants/UnitFields";
import useFetch from "hooks/useFetch";
import StatusTag from "components/Common/StatusTag";

const fields = _.intersection(FIELD_ORDERS, DETAIL_FIELDS);

const UnitDetailsModal = ({
  showModal,
  unitIndex: propUnitIndex,
  unitListData,
  onClose,
}) => {
  const { responseData: unitImagesResponseData, doFetch: getUnitImages } =
    useFetch("/units/getUnitImages", "GET", []);
  const [unitIndex, setUnitIndex] = useState(propUnitIndex);
  const unitData = unitListData[unitIndex] ?? {};
  const unitImagesData = unitImagesResponseData.data ?? [];

  const renderField = (key, val) => {
    switch (key) {
      case FIELD_KEYS.DETECTED_CODE:
        const fieldColor = !!val?.type
          ? DETECTED_CODE_TYPE_COLOR_MAP[val.type]
          : null;
        const fieldStyle = !!fieldColor
          ? {
              color: fieldColor,
            }
          : {};
        return <span style={fieldStyle}>{val?.value ?? "-"}</span>;
      case FIELD_KEYS.STATUS:
        return <StatusTag status={val} />;
      default:
        return val ?? "-";
    }
  };

  const incrementIndex = () => {
    setUnitIndex(unitIndex + 1);
  };

  const decrementIndex = () => {
    setUnitIndex(unitIndex - 1);
  };

  const fetchUnitImages = () => {
    if (unitData?.images?.length > 0) {
      getUnitImages({
        paths: unitData.images,
      });
    }
  };

  const getNavigationButtons = () => {
    return (
      <Flex>
        <Button
          onClick={decrementIndex}
          disabled={unitIndex === 0}
          icon={<LeftOutlined />}
          block={true}
        >
          Previous Unit
        </Button>
        <Button
          onClick={incrementIndex}
          disabled={unitIndex >= unitListData.length - 1}
          block={true}
        >
          Next Unit
          <RightOutlined />
        </Button>
      </Flex>
    );
  };

  useEffect(() => {
    fetchUnitImages();
  }, [unitIndex]);

  return (
    <>
      <Modal
        title="Unit Details"
        open={showModal}
        onCancel={onClose}
        footer={getNavigationButtons()}
        wrapClassName="modal-wrap-max-content"
        centered={true}
      >
        {getNavigationButtons()}
        <Flex vertical={true} gap="middle" style={{ paddingTop: "1rem" }}>
          <Flex
            justify="center"
            wrap="wrap"
            gap="1rem 3rem"
            style={{ margin: "0 0.5rem" }}
          >
            {fields.map((fieldKey, index) => (
              <div key={index}>
                <Space>
                  <span style={{ fontWeight: "500" }}>
                    {FIELD_LABELS[fieldKey]}
                  </span>
                  : {renderField(fieldKey, unitData[fieldKey])}
                </Space>
              </div>
            ))}
          </Flex>
          <Flex wrap="wrap" gap="small" justify="center">
            {unitImagesData.length > 0 ? (
              <Image.PreviewGroup>
                {unitImagesData.map((image, index) => (
                  <>
                    <Flex
                      key={"unit_" + unitIndex + "_image_" + index}
                      align="center"
                      wrap="wrap"
                      vertical={true}
                    >
                      <span style={{ fontWeight: "700" }}>{image.name}</span>
                      <Image
                        width={400}
                        height={400}
                        src={image.data}
                        fallback={FALLBACK_IMAGE}
                      />
                    </Flex>
                  </>
                ))}
              </Image.PreviewGroup>
            ) : (
              <Image
                width={400}
                height={400}
                src="error"
                fallback={FALLBACK_IMAGE}
              />
            )}
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};

export default UnitDetailsModal;
